import { Fetch } from '../../shared/types';
import type { Zap } from '../types';

type Options = {
  accountId: number;
  zapId: Zap['id'];
};

export const getZap = async (
  fetch: Fetch,
  { accountId, zapId }: Options
): Promise<Zap> =>
  fetch<Zap>(`/api/gulliver/storage/v1/zaps/${zapId}`, {
    params: {
      account_id: accountId,
    },
  });

export default getZap;
